import { render } from "./PCGestionPaletizado.vue?vue&type=template&id=9562ad34&scoped=true"
import script from "./PCGestionPaletizado.vue?vue&type=script&lang=js"
export * from "./PCGestionPaletizado.vue?vue&type=script&lang=js"

import "./PCGestionPaletizado.vue?vue&type=style&index=0&id=9562ad34&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9562ad34"]])

export default __exports__